import {
  baby_img_lft,
  complementary_card,
  doctor_visit,
  doctor_visiting,
  expreesed,
  expreesed_bottom,
  feeding_bottom,
  feeding_card,
  formula_card,
  formula_card_down,
  graph_down,
  Graph_icons,
  memories_card,
  memories_card_bottom,
  motor_develop,
  pumping_card,
  pumping_card_bottom,
  right_arrow,
  sleep_tracker_card,
  speech_img,
  Teeths,
  Teeting,
  vaccination_img,
} from "assets/icons";
import React, { useEffect, useState } from "react";
import "./BabiesDetails.css";
import MotorSkillsTracking from "./section/motorSkillsTracking/MotorSkillsTracking";
import DoctorVisit from "./section/doctorVist/DoctorVisit";
import GrowthTracking from "./section/growthTracking";
import Speechdevelopment from "./section/SpeechDevelopment/Speechdevelopment";
import Vaccination_record from "./section/VaccinationRecord/Vaccination_record";
import Teething from "./section/teethingtracker/Teething";
import Sleepingtracker from "./section/sleepingTracker/Sleepingtracker";
import useFullPageLoader from "common/UseFullPageLoader";
import { childDashboardDetailApi } from "services/child";
import { Link, useParams } from "react-router-dom";
import { formatToDDMMYYYY } from "utils/dateFormat";
import { firstWordCapital, formatTime, getAgeInWords } from "utils/common";
import moment from "moment";
import Formula from "./section/formula/Formula";
import Memories_card from "./section/memories/Memories_card";
import Feeding from "./section/feeding/Feeding";
import Pumping from "./section/pumping/Pumping";
import Diaper_changing from "./section/diaper_Changing/Diaper_changing";
import Expressed_feeding from "./section/Expressed_Feeding/expressed_feeding";
import Complementry from "./section/complementry_Feeding/Complementry";

const BabiesDetails = () => {
  const { babyId } = useParams();
  const [babyDetailsCard, setBabyDetailsCard] = useState("growthTracking");
  const [childDetail, setChildDetail] = useState([]);
  const [loader, onShow, onHide] = useFullPageLoader();

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await childDashboardDetailApi({
        childId: babyId,
      });
      if (status === 200) {
        setChildDetail(data?.data);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const child = childDetail?.childMapping?._child;

  return (
    <>
      <div className="breadcrumb">
        <ul>
          <li>
            <Link to={-1}>User Management</Link>
          </li>

          <li>
            <Link to={-1}>User details</Link>
          </li>
          <li>Child details</li>
        </ul>
      </div>
      <div className="Babies_details_parent _box">
        <div className="babies_details_wrap">
          <div className="babies_details_lft">
            <img
              src={
                child?.profilePicture?.length
                  ? child?.profilePicture
                  : baby_img_lft
              }
            />
            <div className="babies_details_id">
              <p>
                <span>ID:</span>
                <span>{child?.childId}</span>
              </p>
            </div>
          </div>

          <div className="babies_details_rgt">
            <div className="child_old">
              <span>{getAgeInWords(child?.dateOfBirth)}</span>
            </div>

            <ul>
              <li>
                <b>Kid Name</b>
                <span>{child?.fullName}</span>
              </li>

              <li>
                <b>Gender</b>
                <span>{firstWordCapital(child?.gender?.toLowerCase())}</span>
              </li>

              <li>
                <b>DOB</b>
                <span> {formatToDDMMYYYY(child?.dateOfBirth)}</span>
              </li>

              <li>
                <b>Birth Weight</b>
                <span>{`${child?.weightMeasurement?.value} ${firstWordCapital(
                  child?.weightMeasurement?.unit?.toLowerCase()
                )}`}</span>
              </li>

              <li>
                <b>Birth Height</b>
                <span>{`${child?.heightMeasurement?.value} ${firstWordCapital(
                  child?.heightMeasurement?.unit?.toLowerCase()
                )}`}</span>
              </li>

              <li>
                <b>Birth Head</b>
                <span>{`${child?.headMeasurement?.value} ${firstWordCapital(
                  child?.headMeasurement?.unit?.toLowerCase()
                )}`}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="baby_detail_cards">
          <div className="row">
            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "growthTracking" ? "card_bg_color" : ""
                  }`}
                onClick={() => setBabyDetailsCard("growthTracking")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={Graph_icons} className="graph_icon" />
                      <div className="card_heading">
                        <p>Growth Tracking</p>
                      </div>
                    </div>
                    <p className="few_second">
                      {moment(
                        childDetail?.latestGrowthTrackingDateTime
                      ).fromNow()}
                    </p>
                  </div>

                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <ul>
                    <li>
                      <span>Height</span>{" "}
                      <b>{`${childDetail?.heightMeasurement?.value
                        } ${firstWordCapital(
                          childDetail?.heightMeasurement?.unit?.toLowerCase()
                        )}`}</b>
                    </li>

                    <li>
                      <span>Width</span>{" "}
                      <b>{`${childDetail?.weightMeasurement?.value
                        } ${firstWordCapital(
                          childDetail?.weightMeasurement?.unit?.toLowerCase()
                        )}`}</b>
                    </li>

                    <li>
                      <span>Head</span>{" "}
                      <b>{`${childDetail?.headMeasurement?.value
                        } ${firstWordCapital(
                          childDetail?.headMeasurement?.unit?.toLowerCase()
                        )}`}</b>
                    </li>
                  </ul>

                  <img src={graph_down} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "motorSkillsTracking"
                  ? "card_bg_color"
                  : ""
                  }`}
                onClick={() => setBabyDetailsCard("motorSkillsTracking")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={motor_develop} className="graph_icon" />
                      <div className="card_heading">
                        <p>Motor Skills Tracking</p>
                      </div>
                    </div>

                    <p className="few_second">
                      {moment(childDetail?.motorSkill?.createdAt).fromNow()}
                    </p>
                  </div>

                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <p className="footer_lft_content">
                    {childDetail?.motorSkill?.name || ""}
                  </p>

                  <img src={graph_down} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "speechDevelopment" ? "card_bg_color" : ""
                  }`}
                onClick={() => setBabyDetailsCard("speechDevelopment")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={speech_img} className="graph_icon" />

                      <div className="card_heading">
                        <p>Speech Development Trac...</p>
                      </div>
                    </div>

                    <p className="few_second">2 hours ago</p>
                  </div>

                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <p className="footer_lft_content">80 word</p>

                  <img src={graph_down} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "vaccinationRecords"
                  ? "card_bg_color"
                  : ""
                  }`}
                onClick={() => setBabyDetailsCard("vaccinationRecords")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={vaccination_img} className="graph_icon" />

                      <div className="card_heading">
                        <p>Vaccination Records</p>
                      </div>
                    </div>
                    <p className="few_second">
                      {moment(childDetail?.vaccination?.createdAt).fromNow()}
                    </p>
                  </div>

                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <p className="footer_lft_content">
                    {childDetail?.vaccination?.vaccineName || ""}
                  </p>
                  <img src={graph_down} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "doctorVisit" ? "card_bg_color" : ""
                  }`}
                onClick={() => setBabyDetailsCard("doctorVisit")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={doctor_visit} className="graph_icon" />

                      <div className="card_heading">
                        <p>Doctor Visits</p>
                      </div>
                    </div>
                    <p className="few_second">
                      {moment(childDetail?.doctorVisit?.createdAt).fromNow()}
                    </p>
                  </div>

                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <ul>
                    <li>
                      <span>Last Visit</span>{" "}
                      <b>
                        {formatToDDMMYYYY(childDetail?.doctorVisit?.dateTime)}
                      </b>
                    </li>

                    {/* <li>
                      <span>Next Visit</span> <b>26 Nov 2024</b>
                    </li> */}
                  </ul>

                  <img src={doctor_visiting} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "teethingTracker" ? "card_bg_color" : ""
                  }`}
                onClick={() => setBabyDetailsCard("teethingTracker")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={Teeting} className="graph_icon" />
                      <div className="card_heading">
                        <p>Teething Tracker</p>
                      </div>
                    </div>
                    <p className="few_second">
                      {moment(childDetail?.teethTracking?.createdAt).fromNow()}
                    </p>
                  </div>

                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <p className="footer_lft_content">
                    {childDetail?.teethTracking?.name || ""}
                  </p>

                  <img src={Teeths} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "complementaryFeeding"
                  ? "card_bg_color"
                  : ""
                  }`}
                onClick={() => setBabyDetailsCard("complementaryFeeding")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={complementary_card} className="graph_icon" />

                      <div className="card_heading">
                        <p>Complementary Feeding</p>
                      </div>
                    </div>
                    <p className="few_second">
                      {moment(
                        childDetail?.complementaryFeeding?.createdAt
                      ).fromNow()}
                    </p>
                  </div>
                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <ul>
                    <li>
                      <span>Last Taken</span>{" "}
                      <b>
                        {formatToDDMMYYYY(
                          childDetail?.complementaryFeeding?.feedingDateTime
                        )}
                      </b>
                    </li>
                  </ul>

                  <img src={graph_down} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "sleepTracker" ? "card_bg_color" : ""
                  }`}
                onClick={() => setBabyDetailsCard("sleepTracker")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={sleep_tracker_card} className="graph_icon" />

                      <div className="card_heading">
                        <p>Sleep Tracker</p>
                      </div>
                    </div>
                    <p className="few_second">
                      {moment(childDetail?.sleepTracker?.createdAt).fromNow()}
                    </p>
                  </div>
                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <p className="footer_lft_content">
                    {childDetail?.sleepTracker?.totalDuration ? formatTime(childDetail?.sleepTracker?.totalDuration) : ""}
                  </p>

                  <img src={graph_down} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "formula" ? "card_bg_color" : ""
                  }`}
                onClick={() => setBabyDetailsCard("formula")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={formula_card} className="graph_icon" />

                      <div className="card_heading">
                        <p>Formula</p>
                      </div>
                    </div>
                    <p className="few_second">
                      {moment(childDetail?.sleepTracker?.createdAt).fromNow()}
                    </p>
                  </div>
                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <p className="footer_lft_content">
                    {`${childDetail?.formulaFeeding?.value || ""} ${childDetail?.formulaFeeding?.unit || ""}`}
                  </p>

                  <img src={formula_card_down} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "memories" ? "card_bg_color" : ""
                  }`}
                onClick={() => setBabyDetailsCard("memories")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={memories_card} className="graph_icon" />

                      <div className="card_heading">
                        <p>Memories</p>
                      </div>
                    </div>
                    <p className="few_second">
                      {moment(childDetail?.sleepTracker?.createdAt).fromNow()}
                    </p>
                  </div>
                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <p className="footer_lft_content">
                    {moment(childDetail?.memories?.dateTime).format("LL")}
                  </p>

                  <img src={memories_card_bottom} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "feeding" ? "card_bg_color" : ""
                  }`}
                onClick={() => setBabyDetailsCard("feeding")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={feeding_card} className="graph_icon" />

                      <div className="card_heading">
                        <p>Feeding</p>
                      </div>
                    </div>
                    <p className="few_second">
                      {moment(childDetail?.sleepTracker?.createdAt).fromNow()}
                    </p>
                  </div>
                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <p className="footer_lft_content">
                    Left: {childDetail?.breastFeeding?.leftSideTime || ""} sec
                  </p>
                  <p className="footer_lft_content">
                    Right: {childDetail?.breastFeeding?.rightSideTime || ""} sec
                  </p>

                  <img src={feeding_bottom} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "pumping" ? "card_bg_color" : ""
                  }`}
                onClick={() => setBabyDetailsCard("pumping")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={pumping_card} className="graph_icon" />

                      <div className="card_heading">
                        <p>Pumping</p>
                      </div>
                    </div>
                    <p className="few_second">
                      {moment(childDetail?.sleepTracker?.createdAt).fromNow()}
                    </p>
                  </div>
                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <p className="footer_lft_content">
                    Left: {`${childDetail?.pumpFeeding?.leftSide?.value || ""} ${childDetail?.pumpFeeding?.leftSide?.unit || ""}`}
                  </p>

                  <p className="footer_lft_content">
                    Right: {`${childDetail?.pumpFeeding?.leftSide?.value || ""} ${childDetail?.pumpFeeding?.leftSide?.unit || ""}`}
                  </p>

                  <img src={pumping_card_bottom} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "expressed_feeding" ? "card_bg_color" : ""
                  }`}
                onClick={() => setBabyDetailsCard("expressed_feeding")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={expreesed} className="graph_icon" />

                      <div className="card_heading">
                        <p>Expressed Feeding</p>
                      </div>
                    </div>
                    <p className="few_second">
                      {moment(childDetail?.sleepTracker?.createdAt).fromNow()}
                    </p>
                  </div>
                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <p className="footer_lft_content">
                    {`${childDetail?.expressFeeding?.value || ""} ${childDetail?.expressFeeding?.unit || ""}`}
                  </p>

                  <img src={expreesed_bottom} className="card_down" />
                </div>
              </div>
            </div>

            <div className=" col-sm-4 col-md-4 col-lg-4">
              <div
                className={`parent_card ${babyDetailsCard === "diaper_changing" ? "card_bg_color" : ""
                  }`}
                onClick={() => setBabyDetailsCard("diaper_changing")}
              >
                <div className="card_header_wraper">
                  <div className="card_top_img_wrap">
                    <div className="card_img">
                      <img src={formula_card} className="graph_icon" />

                      <div className="card_heading">
                        <p>Diaper Changing</p>
                      </div>
                    </div>
                    <p className="few_second">
                      {moment(childDetail?.sleepTracker?.createdAt).fromNow()}
                    </p>
                  </div>
                  <div className="arrow_img">
                    <img src={right_arrow} />
                  </div>
                </div>

                <div className="card_footer">
                  <p className="footer_lft_content">
                    {moment(childDetail?.diaper?.dateTime).format("LL")}
                  </p>

                  <img src={formula_card_down} className="card_down" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabber */}

        {babyDetailsCard === "growthTracking" && (
          <GrowthTracking _child={babyId} />
        )}

        {babyDetailsCard === "motorSkillsTracking" && (
          <>
            <MotorSkillsTracking _child={babyId} />
          </>
        )}

        {babyDetailsCard === "speechDevelopment" && (
          <>
            <Speechdevelopment _child={babyId} />
          </>
        )}

        {babyDetailsCard === "vaccinationRecords" && (
          <>
            <Vaccination_record _child={babyId} />
          </>
        )}

        {babyDetailsCard === "doctorVisit" && (
          <>
            <DoctorVisit _child={babyId} />
          </>
        )}

        {babyDetailsCard === "teethingTracker" && (
          <>
            <Teething _child={babyId} />
          </>
        )}

        {babyDetailsCard === "complementaryFeeding" && (
          <>
            <Complementry _child={babyId} />
          </>
        )}

        {babyDetailsCard === "sleepTracker" && (
          <>
            <Sleepingtracker _child={babyId} />
          </>
        )}

        {babyDetailsCard === "formula" && (
          <>
            <Formula _child={babyId} />
          </>
        )}

        {babyDetailsCard === "memories" && (
          <>
            <Memories_card _child={babyId} />
          </>
        )}

        {babyDetailsCard === "feeding" && (
          <>
            <Feeding _child={babyId} />
          </>
        )}

        {babyDetailsCard === "pumping" && (
          <>
            <Pumping _child={babyId} />
          </>
        )}

        {babyDetailsCard === "expressed_feeding" && (
          <>
            <Expressed_feeding _child={babyId} />
          </>
        )}

        {babyDetailsCard === "diaper_changing" && (
          <>
            <Diaper_changing _child={babyId} />
          </>
        )}
      </div>
    </>
  );
};

export default BabiesDetails;
